import type Owner from '@ember/owner';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class NoResultsClientsComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.classNames = 'view-clients';

		this.titleText = 'Manage all your accounts in one place';

		this.descText =
			'Organize reporting across clients, brands, locations, franchises, and business units by giving each one its own account while keeping everything connected to your organization.';

		this.readMoreUrl = 'https://help.databox.com/understanding-client-accounts';

		this.topImageLightUrl = '/images/placeholders/clients.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/clients.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-clients.svg';
		this.imageDarkUrl = '/images/placeholders/dark/placeholder-clients.svg';
		this.imageHeight = 562;

		this.trackingOrigin = 'clients';
	}

	override get createButtonText() {
		if (!this.accountService.canAddClient) {
			return '';
		}

		return 'Add account';
	}
}
